var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 9.99984L7.99996 7.99984M7.99996 7.99984L5.99996 5.99984M7.99996 7.99984L5.99996 9.99984M7.99996 7.99984L9.99996 5.99984M0.666626 7.99984C0.666626 12.0499 3.94987 15.3332 7.99996 15.3332C12.05 15.3332 15.3333 12.0499 15.3333 7.99984C15.3333 3.94975 12.05 0.666504 7.99996 0.666504C3.94987 0.666504 0.666626 3.94975 0.666626 7.99984Z",
    stroke: "#E33B32",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartDeleteIcon);
export default __webpack_public_path__ + "static/media/startDeleteIcon.adfae000cfaaca592b3027744cc5a942.svg";
export { ForwardRef as ReactComponent };